import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_ACCESS_DENIED_REDIRECT = new HttpContextToken<boolean>(() => false);
